import React, { useMemo } from "react";
import { shallowEqual } from "react-redux";
import Dialog from "../../components/Dialog";
import ChatPage from "./ChatPage";
import ChatLayout from "./components/chatLayout/ChatLayout";
import NewChatActions from "./components/newChatActions/NewChatActions";
import { useChatsUIContext } from "./context/ChatsContext";
import { useChatSelector } from "./hooks/reduxHook";
import { useAppTranslation } from "../../i18n/useAppTranslation";

const ChatWrapper = () => {
  const { t } = useAppTranslation("common");
  const socketIo = useChatSelector(
    (state: any) => state.chats.socketIo,
    shallowEqual
  );

  const chatsContext = useChatsUIContext();
  const chatsUIProps = useMemo(() => {
    return {
      confirmDialog: chatsContext?.confirmDialog,
      setConfirmDialog: chatsContext?.setConfirmDialog,
      newChatActionsShow: chatsContext?.newChatActionsShow,
    };
  }, [
    chatsContext?.confirmDialog,
    chatsContext?.setConfirmDialog,
    chatsContext?.newChatActionsShow,
  ]);

  if (!socketIo) return null;

  return (
    <ChatLayout>
      <>
        {/* Chat Contents */}
        <ChatPage />
        {/* Chat Contents */}
        <Dialog
          noTitle={!chatsUIProps?.confirmDialog?.title}
          closeLabel={t("actions.no")}
          style={{ zIndex: 2222, width: "100%", maxWidth: "25rem" }}
          submitLabel={t("actions.yes")}
          size="sm"
          onSubmit={chatsUIProps?.confirmDialog?.submit}
          open={!!chatsUIProps?.confirmDialog?.open}
          title={chatsUIProps?.confirmDialog?.title}
          onClose={() =>
            chatsUIProps?.setConfirmDialog?.((prev) => ({
              ...prev,
              open: false,
            }))
          }
          className="dialog-sm text-center chat-confirm-dialog"
        >
          {chatsUIProps?.confirmDialog?.msg}
        </Dialog>
        {chatsUIProps?.newChatActionsShow && <NewChatActions />}
      </>
    </ChatLayout>
  );
};
export default ChatWrapper;
